import { render, staticRenderFns } from "./sc_market.vue?vue&type=template&id=64cbc844&scoped=true"
import script from "./sc_market.vue?vue&type=script&lang=js"
export * from "./sc_market.vue?vue&type=script&lang=js"
import style0 from "./sc_market.vue?vue&type=style&index=0&id=64cbc844&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cbc844",
  null
  
)

export default component.exports